<p-dialog-container>
    <p-dialog-header
        [title]="'UserProfile.Security.ChangePassword.header' | translate"
        [infoTooltip]="'UserProfile.changePassTooltip' | translate"
    ></p-dialog-header>
    <div class="p-dialog-content" [formGroup]="form" pLabelAligner=".p-field-label">
        <p-field-text
            [label]="'UserProfile.currPass' | translate"
            formControlName="password"
            type="password"
            name="password"
            id="password"
        ></p-field-text>
        <p-field-text
            [label]="'UserProfile.newPass' | translate"
            formControlName="newPassword"
            type="password"
            [errorMessage]="errMsgInvalid"
        ></p-field-text>
        <p-field-text
            [label]="'UserProfile.reNewPass' | translate"
            formControlName="reNewPassword"
            type="password"
            [errorMessage]="errMsg"
        ></p-field-text>
    </div>
    <p-dialog-footer [btnConfig]="footerConfig"></p-dialog-footer>
</p-dialog-container>
